export enum MetricAggregation {
  Count = 'Count',
  Sum = 'Sum',
  Average = 'Average',
}
